import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TaxRate } from 'app/core/models/taxRate';
import { TaxRateTable } from 'app/core/models/TaxRateTable';
import { NotifMessageService } from 'app/core/services/notifmessage.service';
import { TaxManagementService } from 'app/core/services/tax-management.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-tax-management',
  templateUrl: './tax-management.component.html',
  styleUrls: ['./tax-management.component.css']
})
export class TaxManagementComponent implements OnInit {

  @ViewChild('submitTaxManagementBtn') submitTaxManagementBtn: ElementRef;

  @Input() merchantId: number;
  @Input() isEditMode: boolean;
  @Input() isDetailsMode: boolean;

  private isLoading: boolean = true;
  private taxRateTable: TaxRateTable;
  private taxRateForm: FormGroup;
  private isPristine: boolean = true;

  constructor(
    private log: NGXLogger,
    private formBuilder: FormBuilder,
    private taxMgtService: TaxManagementService,
    private notifService: NotifMessageService,
  ) {
    this.taxRateForm = this.formBuilder.group({
      countryCode: new FormControl('', [Validators.required, Validators.pattern("[A-Z]{2}")]),
      vatRate: new FormControl('', [Validators.required, Validators.pattern("\\d+")])
    });
  }

  ngOnInit(): void {
    this.log.debug("ngOnInit TaxManagementComponent");
    this.fetchTaxRateTable();
  }

  fetchTaxRateTable(): void {
    // Create observer object
    const taxObserver = {
      next: (t: TaxRateTable) => {
        this.taxRateTable = t;
        this.isLoading = false;
      },
      error: (err: Error) => {
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    };
    this.taxMgtService.getTaxRateTableByMerchantId(this.merchantId).subscribe(taxObserver);
  }

  saveTaxRateTable(): void {
        // Create observer object
        const taxObserver = {
          next: (t: TaxRateTable) => {
            this.taxRateTable = t;
            this.isLoading = false;
            this.notifService.notifySuccess('SAVED');
          }
        };
    if (this.taxRateTable.id != null) {
      this.taxMgtService.updateTaxRateTable(this.taxRateTable).subscribe(t => this.taxRateTable = t);
    } else {
      this.taxMgtService.createTaxRateTable(this.taxRateTable).subscribe(t => this.taxRateTable = t);
    }
    this.notifService.notifySuccess("SAVED");
    this.submitTaxManagementBtn.nativeElement.blur();
  }

  get currentEditRate() {
    return this.taxRateForm.controls;
  }

  addRate(): void {
    if (this.taxRateTable == null) {
      this.taxRateTable = new TaxRateTable();
      this.taxRateTable.merchantId = this.merchantId;
    }
    let newTaxRate: TaxRate = new TaxRate();
    newTaxRate.countryCode = this.taxRateForm.get("countryCode").value;
    newTaxRate.vatRate = this.taxRateForm.get("vatRate").value;
    // If this country exists in the table, we replace it
    const index = this.taxRateTable.rates.findIndex(entry => entry.countryCode == newTaxRate.countryCode);
    if (index > -1) {
      this.taxRateTable.rates[index] = newTaxRate;
    } else {
      this.taxRateTable.rates.push(newTaxRate);
    }
    this.taxRateForm.reset();
    this.isPristine = false;
  }

  removeRate(countryCode: string): void {
    if (this.taxRateTable != null) {
      const index = this.taxRateTable.rates.findIndex(entry => entry.countryCode == countryCode);
      if (index > -1) {
        this.taxRateTable.rates.splice(index, 1);
        this.isPristine = false;
      }
    }
  }

  isSubmitDisabled(): boolean {
    return this.taxRateTable == null || this.taxRateTable == undefined || this.isPristine == true;
  }
}
